import { render } from "./Holidays.vue?vue&type=template&id=a1a1307a&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"

import "./Holidays.vue?vue&type=style&index=0&id=a1a1307a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a1307a"]])

export default __exports__